export default "https://cdn-static.gokick.com/assets/33ce344a4b715ce65918e7685bcdda5ecb423fac/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";